// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { Tournament } from "./../../models/tournament";
// Services

import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { AngularFireDatabase } from "angularfire2/database";
import { ElasticService } from "app/services/elastic";

@Component({
  templateUrl: "./proshop-dashboard.component.html",
})
export class ProshopDashboardComponent implements OnInit {
  public club: any;
  public orderAmount = 0;
  public offercount = 0;
  public orderCount = 0;
  public teeTime = 0;
  public eventCount = 0;
  public raffleList: any;
  constructor(
    private apiService: ApiService,
    private elasticService: ElasticService,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase
  ) {}

  async ngOnInit() {
    this.club = this.oAuthService.getClub();
    console.log(this.club);

    await this.getOfferCount();
    await this.getRaffleList();

    // let res = await this.apiService.list("user-booking-teetimes")
    // console.log(res);

    // this.teeTime = res.length
  }

  getOfferCount() {
    let promise = new Promise((resolve, reject) => {
      let count = 0;
      this.orderAmount = 0;
      console.log("pro club", this.club);

      const fireObject = this.fireDatabase
        .object(`/user-offers/${this.club.cid}`)
        .subscribe((result) => {
          if (result) {
            const l = lodash.forEach(result, (item, key) => {
              if (item) {
                item.$key = key;
                if (item.offerType != 3) {
                  count++;
                  ++this.offercount;
                } else if (item.offerType == 3) {
                  ++this.eventCount;
                }
                this.fireDatabase
                  .list(`/offer-orders/${key}`)
                  .subscribe((order) => {
                    if (order) {
                      lodash.forEach(order, (item1, key1) => {
                        if (item1) {
                          if (item1.payment) {
                            if (item1.payment.paymentStatus) {
                              ++this.orderCount;

                              this.orderAmount += item1.payment.amount;
                            }
                          }
                        }
                      });
                    }
                  });
              }
            });
            resolve();
          } else {
            resolve();
          }
        });
    });
    return promise;
  }

  async getRaffleList() {

    let raffleList = await this.apiService.list('raffles');
    raffleList.sort((a, b) => {
      return (new Date(a.startDate)).getTime() - (new Date(b.startDate)).getTime();
    });
    let list = [];
    raffleList.forEach(raffle => {
      raffle.isSelected = false;
      if (raffle.userId == this.club.uid && raffle.uid == this.club.cid) {
        list.push(raffle);
      }
    });

    this.raffleList = list;
  }
}
